<template>
  <a-popconfirm
    :title="'delete-widget-access-key.icon-remove-quest' | globalize"
    :ok-text="'delete-widget-access-key.icon-remove-answer-yes' | globalize"
    :cancel-text="'delete-widget-access-key.icon-remove-answer-no' | globalize"
    @confirm="onClick"
  >
    <a-button
      v-ripple
      :title="'delete-widget-access-key.btn-remove' | globalize"
      type="default"
    >
      <i class="mdi mdi-trash-can-outline" />
    </a-button>
  </a-popconfirm>
</template>

<script>
import AButton from 'ant-design-vue/lib/button'
import APopConfirm from 'ant-design-vue/lib/popconfirm'

export default {
  name: 'delete-widget-access-key',
  components: {
    AButton,
    'a-popconfirm': APopConfirm,
  },
  props: {
    onClick: {
      type: Function,
      default: () => {},
    },
  },
}
</script>

<style lang="scss" scoped>
  @import '~ant-design-vue/lib/button/style/index.css';
  @import '~ant-design-vue/lib/popover/style/index.css'

</style>
